import { useCall } from "@usedapp/core"
import type { Falsy } from "@usedapp/core/dist/esm/src/model/types"
import { Contract } from "ethers"
import { BITSabi } from "web3/abi/bits"

export function useTokenBalanceInner(tokenAddress: string | Falsy, address: string | Falsy) {
  const { value, error } =
    useCall(
      address &&
        tokenAddress && {
          contract: new Contract(tokenAddress, BITSabi),
          method: "balanceOf",
          args: [address],
        },
    ) ?? {}
  if (error) {
    console.error(error.message)
    return undefined
  }
  return value?.[0]
}
